/**
 * Honcho-related constants shared between frontend and backend
 */

export const ASSISTANT_ID = 'assistant'
